
import state from './moduleMailServerState.js'
import mutations from './moduleMailServerMutations.js'
import actions from './moduleMailServerActions.js'
import getters from './moduleMailServerGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
